import React, { useEffect, useState } from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import axiosConn from "config/axiosConn";

const CircleChart2 = ({ state, district }) => {
  const [data, setNewData] = useState([]);

  useEffect(() => {
    getSchoolList(state, district);
  }, [state, district]); 

  const getSchoolList = async (state, district) => {
    try {
      const response = await axiosConn("post", "age-wise-count", { state, district });

      if (response.data.status === "success") {
        const fetchedData = [
          { label: "Age 3 to 8", value: response.data.data.number_participant_age3to8 || 0, color: "#007BFF" }, // Blue
          { label: "Age 8 to 11", value: response.data.data.number_participant_age8to11 || 0, color: "#28A745" }, // Green
          { label: "Age 11 to 14", value: response.data.data.number_participant_age11to14 || 0, color: "#FFA500" }, // Orange
          { label: "Age 14 to 18", value: response.data.data.number_participant_age14to18 || 0, color: "#FF5733" }, // Red
          { label: "Age 18 plus", value: response.data.data.number_participant_age18plus || 0, color: "#17A2B8" }, // Teal
        ];
        setNewData(fetchedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const TOTAL = data.reduce((acc, item) => acc + item.value, 0);

  const getArcLabel = (params) => {
    const percent = TOTAL ? (params.value / TOTAL) : 0;
    return ` ${(percent * 100).toFixed(0)}%`;
  };

  return (
    <div style={{ marginBottom: "70px"}}>
      <PieChart
        series={[
          {
            data: data.map((item, index) => ({
              id: index,
              value: item.value,
              label: item.label,
              color: item.color, // Color assignment
            })),
            outerRadius: 130, // Adjusted for more space
            arcLabel: getArcLabel,
            //labelPosition: "outside",
          },
        ]}
        width={600}
        height={400}
        sx={{
          [`& .${pieArcLabelClasses.root}`]: {
            fill: "white",
            fontSize: 15,
            transform: "translate(15px, -5px)",
          },
        }}
      />
    </div>
  );
};

export default CircleChart2;
